import { useSubscription } from "@apollo/client";
import { GENERATE_POST_TITLE } from "@/modules/ai/features/generate-post-title/api/generate-post-title";
import { useState } from "react";
import { useAiGenerationState } from "@/modules/ai/shared/model/use-ai-generation-state";

export function useGeneratePostTitle() {
  const [content, setContent] = useState<string | undefined>(undefined);

  const { generating, start, finish } = useAiGenerationState();

  const { data, restart } = useSubscription(GENERATE_POST_TITLE, {
    variables: {
      content: content as string,
    },
    skip: !content,
    onComplete: finish,
    onError: finish,
  });

  const generate = (value: string) => {
    if (!value) return;

    start();

    // с теми же переменными подписка сама не перезапустится
    if (value === content) restart();
    else setContent(value);
  };

  return {
    title:
      data?.aiGenerateTitle.__typename === "UpdateMessageAiChatMessage"
        ? data?.aiGenerateTitle.text
        : undefined,

    loading: generating,
    generate,
  };
}
